/**
 * roofEvents — shared util for the iter168 'roof_details changed'
 * cross-component refresh signal.
 *
 * Any page/component that mutates roof_details (POST/PUT/DELETE
 * /api/roof-details/...) should call `fireRoofDetailsChanged()` after
 * a successful save so every mounted <BuilderRoofDetailsPanel> + the
 * Components-tab QuickBar re-fetch their data without a full reload.
 *
 * The event name is intentionally `rtr:roof-details-changed` (lower
 * case + hyphen) so it doesn't collide with any built-in DOM event.
 */
export const ROOF_DETAILS_CHANGED_EVENT = 'rtr:roof-details-changed';

export function fireRoofDetailsChanged() {
  try {
    window.dispatchEvent(new CustomEvent(ROOF_DETAILS_CHANGED_EVENT));
  } catch (_) {
    /* SSR / non-browser env — swallow */
  }
}

/**
 * Convenience hook-style helper: subscribe to the event with an
 * automatic cleanup. Usage:
 *   useEffect(() => onRoofDetailsChanged(load), [load]);
 */
export function onRoofDetailsChanged(handler) {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(ROOF_DETAILS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(ROOF_DETAILS_CHANGED_EVENT, handler);
}
